import styled from "@emotion/styled";

export const PaginationWrapper = styled.div(({theme}) => ({
  gridColumn: theme?.breakpoints?.isMobile ? "1/-1" : "7/11",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginInline: "auto",
  marginTop: 20,
}));

export const PageItem = styled.span(({isActive, theme}) => ({
  color: isActive ? theme?.colors?.primaryBlack : theme?.colors?.primaryGrey,
  fontSize: "1rem",
  lineHeight: 1.4,
  fontWeight: 400,
  fontFamily: theme?.font?.manrope,
  transition: "color 0.3s ease-in-out",
  cursor: "pointer",
  ":hover": {
    color: theme?.colors?.primaryBlack,
  },
}));

export const GreyLine = styled.div(({theme}) => ({
  backgroundColor: theme?.colors?.primaryGrey,
  width: 1,
  height: 12,
  marginRight: 10,
  marginLeft: 10,
}));

export const ArrowLeftWrapper = styled.div(({active}) => ({
  marginRight: 25,
  cursor: active ? "pointer" : "default",
}));

export const ArrowRightWrapper = styled.div(({active}) => ({
  marginLeft: 25,
  cursor: active ? "pointer" : "default",
}));
